import React, { useEffect, useState } from "react";
import MainLayout from "../../components/Layouts/MainLayout";
import TasksList from "../../components/Reviewer/TasksList";
import { useSelector } from "react-redux";
import apiClient from '../../api/apiClient';
function Tasks() {
 const { user } = useSelector((state) => state.auth);

  const [tasksNumber, setTasksNumber] = useState(0);
  const [tasksToday, setTasksToday] = useState(0);
  const [acceptedRatio, setAcceptedRatio] = useState(0);
  const [rejectedRatio, setRejectedRatio] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  // Time of day greeting
  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return "Good morning";
    if (hour < 18) return "Good afternoon";
    return "Good evening";
  };

  const getTasksData = async () => {
    setIsLoading(true);
    try {
      const response = await apiClient.get(`/api/dashboard/reviewer/`);
      setTasksNumber(response.data.total_tasks_reviewed);
      setTasksToday(response.data.reviewed_today);
      setAcceptedRatio(response.data.accepted_tasks_ratio);
      setRejectedRatio(response.data.rejected_tasks_ratio);
    } catch (error) {
      console.error("Failed to fetch reviewer data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getTasksData();
  }, []);

  useEffect(() => {
    getTasksData();
  }, []);

  return (
    <MainLayout>
      <main className="p-4 md:ml-64 min-h-screen pt-10 bg-gradient-to-br  dark:from-gray-900 dark:to-gray-800">
        <div className="max-w-7xl mx-auto sm:px-6 py-10 mb-5">
          {/* Header Section with Animated Greeting */}
          <div className="px-4 sm:px-0 mb-8">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between">
              <div className="mb-4 md:mb-0">
                <span className="inline-block px-3 py-1 text-sm font-medium text-emerald-800 bg-emerald-100 rounded-full dark:bg-emerald-900 dark:text-emerald-200">
                  {getGreeting()}
                </span>
                <h1 className="mt-2 text-3xl md:text-4xl font-extrabold text-gray-900 dark:text-white">
                  Hello, <span className="text-emerald-600 dark:text-emerald-400">{user?.first_name}</span>!
                </h1>
                <p className="mt-1 text-gray-600 dark:text-gray-300">
                  Your reviewer dashboard overview
                </p>
              </div>
         
            </div>
          </div>

          {/* Stats Section */}
          <div className="px-4 sm:px-0 mb-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Review Stats Card */}
              <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-100 dark:bg-gray-800 dark:border-gray-700">
                <div className="p-6">
                  <div className="flex justify-between items-center mb-6">
                    <h2 className="text-lg font-bold text-gray-800 dark:text-white">Review Activity</h2>
                    {/* <span className="text-xs font-medium px-2.5 py-0.5 rounded-full bg-emerald-100 text-emerald-800 dark:bg-emerald-900 dark:text-emerald-200">
                      Current Month
                    </span> */}
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                    {/* Total Reviewed Card */}
                    <div className=" rounded-lg p-4 dark:from-gray-700 dark:to-gray-700 relative overflow-hidden">
                      <div className="absolute right-0 top-0 w-20 h-20 opacity-10">
                        <svg className="text-emerald-600 dark:text-emerald-400 w-full h-full" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z"></path>
                          <path fillRule="evenodd" d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z" clipRule="evenodd"></path>
                        </svg>
                      </div>
                      <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-2">
                        Total Tasks Reviewed
                      </h3>
                      {isLoading ? (
                        <div className="animate-pulse h-8 w-16 bg-gray-200 dark:bg-gray-600 rounded"></div>
                      ) : (
                        <div className="flex items-end">
                          <span className="text-3xl font-bold text-gray-900 dark:text-white">{tasksNumber}</span>
                          <div className="ml-2 text-sm font-medium text-emerald-600 dark:text-emerald-400">
                            <span className="flex items-center">
                              <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"></path>
                              </svg>
                              Total
                            </span>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Today's Reviews Card */}
                    <div className=" rounded-lg p-4 dark:from-gray-700 dark:to-gray-700 relative overflow-hidden">
                      <div className="absolute right-0 top-0 w-20 h-20 opacity-10">
                        <svg className="text-cyan-600 dark:text-cyan-400 w-full h-full" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd"></path>
                        </svg>
                      </div>
                      <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-2">
                        Reviewed Today
                      </h3>
                      {isLoading ? (
                        <div className="animate-pulse h-8 w-16 bg-gray-200 dark:bg-gray-600 rounded"></div>
                      ) : (
                        <div className="flex items-end">
                          <span className="text-3xl font-bold text-gray-900 dark:text-white">{tasksToday}</span>
                          {/* <div className="ml-2 text-sm font-medium text-cyan-600 dark:text-cyan-400">
                            Daily Goal: 10
                          </div> */}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Ratio Stats Card */}
              <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-100 dark:bg-gray-800 dark:border-gray-700">
                <div className="p-6">
                  <div className="flex justify-between items-center mb-6">
                    <h2 className="text-lg font-bold text-gray-800 dark:text-white">Review Outcomes</h2>
                    <span className="text-xs font-medium px-2.5 py-0.5 rounded-full bg-cyan-100 text-cyan-800 dark:bg-cyan-900 dark:text-cyan-200">
                      Performance Metrics
                    </span>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                    {/* Accepted Ratio Card */}
                    <div className=" rounded-lg p-4 dark:from-gray-700 dark:to-gray-700 relative overflow-hidden">
                      <div className="absolute right-0 top-0 w-20 h-20 opacity-10">
                        <svg className="text-green-600 dark:text-green-400 w-full h-full" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path>
                        </svg>
                      </div>
                      <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-2">
                        Accepted Task Ratio
                      </h3>
                      {isLoading ? (
                        <div className="animate-pulse h-8 w-16 bg-gray-200 dark:bg-gray-600 rounded"></div>
                      ) : (
                        <div className="flex items-end">
                          <span className="text-3xl font-bold text-gray-900 dark:text-white">{acceptedRatio}%</span>
                          <div className="ml-2 text-sm font-medium text-green-600 dark:text-green-400">
                            <span className="flex items-center">
                              <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                              </svg>
                              Accepted
                            </span>
                          </div>
                        </div>
                      )}
                      <div className="mt-3 w-full bg-gray-200 rounded-full h-1.5 dark:bg-gray-700">
                        <div 
                          className="bg-green-500 h-1.5 rounded-full" 
                          style={{ width: `${acceptedRatio}%` }}
                        ></div>
                      </div>
                    </div>

                    {/* Rejected Ratio Card */}
                    <div className=" rounded-lg p-4 dark:from-gray-700 dark:to-gray-700 relative overflow-hidden">
                      <div className="absolute right-0 top-0 w-20 h-20 opacity-10">
                        <svg className="text-red-500 dark:text-red-400 w-full h-full" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd"></path>
                        </svg>
                      </div>
                      <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-2">
                        Rejected Task Ratio
                      </h3>
                      {isLoading ? (
                        <div className="animate-pulse h-8 w-16 bg-gray-200 dark:bg-gray-600 rounded"></div>
                      ) : (
                        <div className="flex items-end">
                          <span className="text-3xl font-bold text-gray-900 dark:text-white">{rejectedRatio}%</span>
                          <div className="ml-2 text-sm font-medium text-red-600 dark:text-red-400">
                            <span className="flex items-center">
                              <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                              </svg>
                              Rejected
                            </span>
                          </div>
                        </div>
                      )}
                      <div className="mt-3 w-full bg-gray-200 rounded-full h-1.5 dark:bg-gray-700">
                        <div 
                          className="bg-red-500 h-1.5 rounded-full" 
                          style={{ width: `${rejectedRatio}%` }}
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Tasks List Section */}
          <div className="px-4 sm:px-0">
            <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-100 dark:bg-gray-800 dark:border-gray-700">
              <div className="p-6">
                <div className="flex justify-between items-center mb-6">
                  <h2 className="text-lg font-bold text-gray-800 dark:text-white">Tasks To Review</h2>
                  <div>
                    {/* <button className="inline-flex items-center px-3 py-1 text-sm font-medium rounded-md bg-gradient-to-r from-cyan-500 to-emerald-500 text-white hover:from-cyan-600 hover:to-emerald-600 transition-all duration-200">
                      <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"></path>
                      </svg>
                      Filter
                    </button> */}
                  </div>
                </div>
                
                {/* TasksList Component */}
                <TasksList />
              </div>
            </div>
          </div>
        </div>
      </main>
    </MainLayout>
  );
}

export default Tasks;